type Track=(name:string,params?:Record<string,string|number|boolean>)=>void;
/** Only known UI actions and public stand/sensor IDs, never search or form contents. */
export function installTwinAnalytics(doc:Document,track:Track){
 const selectors:Record<string,string>={'.plan-visit':'plan_visit_click','.visit-add':'visit_toggle_stand','.quick-add':'visit_add_stand','.stop-remove':'visit_remove_stand','.visit-toggle':'visit_open','.mobile-plan':'visit_open','.show-walk':'show_walk','.visit-summary button':'walk_preview','.route-actions button':'route_control','.breadcrumbs button':'map_level','.tools button':'map_tool','#liveBtn':'sensor_simulation','#stormBtn':'sensor_storm','#controlsToggle':'scene_controls','.cams button':'camera_preset'};
 const click=(e:Event)=>{
  const el=e.target as Element;if(!el?.closest)return;
  for(const [selector,action] of Object.entries(selectors))if(el.closest(selector)){track('demo_interaction',{action});break;}
 };
 const change=(e:Event)=>{
  const el=e.target as HTMLInputElement;
  if(el.id==='phase')track('construction_phase',{phase:Number(el.value)+1});
  else if(el.type==='checkbox'&&el.closest('#panel'))track('demo_interaction',{action:'layer_toggle',control_id:el.id,enabled:el.checked});
 };
 let previousStand='',previousSensor='',routeShown=false;
 const observe=()=>{
  const stand=doc.querySelector('.stand-number')?.textContent?.trim()||'';
  if(stand!==previousStand){previousStand=stand;if(/^[A-Z0-9-]{1,16}$/.test(stand))track('booth_select',{stand_id:stand});}
  const info=doc.querySelector<HTMLElement>('#info');
  const sensor=info&&info.style.display!=='none'?doc.querySelector('#infoTitle')?.textContent?.trim()||'':'';
  if(sensor!==previousSensor){previousSensor=sensor;if(/^MP_[A-Z0-9_]{1,20}$/.test(sensor))track('sensor_select',{sensor_id:sensor});}
  const planned=!!doc.querySelector('.visit-summary');
  if(planned&&!routeShown)track('visit_route_shown',{stop_count:doc.querySelectorAll('.visit-list li').length});
  routeShown=planned;
 };
 const observer=new MutationObserver(observe);observer.observe(doc.body,{subtree:true,childList:true,characterData:true});
 const info=doc.querySelector('#info');
 const infoObserver=new MutationObserver(observe);if(info)infoObserver.observe(info,{attributes:true,attributeFilter:['style']});
 doc.addEventListener('click',click,true);doc.addEventListener('change',change,true);
 return()=>{observer.disconnect();infoObserver.disconnect();doc.removeEventListener('click',click,true);doc.removeEventListener('change',change,true);};
}
